import DeleteIcon from '../DeleteIcon';
import React from 'react';
import './PropertiesPanel.css';


const PropertiesPanel = ({ element, onUpdate, onDelete }) => {

    if (!element) return (
        <div className="properties-panel">
            <div className="properties-panel-empty">
                Selecione um elemento no canvas para editar as suas propriedades.
            </div>
        </div>
    );


    const handleChange = (field, value) => {
        onUpdate(element.id, { ...element, [field]: value });
    };

    const handleStyleChange = (styleField, value) => {
        onUpdate(element.id, {
            ...element,
            styles: { ...element.styles, [styleField]: value }
        });
    };

    return (
        <div className="properties-panel">
            <div className="properties-header">
                <h3>Propriedades</h3>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <span className="element-badge">{element.type}</span>
                    {onDelete && (
                        <button
                            onClick={() => {
                                if (window.confirm('Apagar este elemento?')) {
                                    onDelete(element.id);
                                }
                            }}
                            style={{
                                background: '#fc8181',
                                border: 'none',
                                borderRadius: '4px',
                                padding: '4px 8px',
                                cursor: 'pointer',
                                fontSize: '0.9em'
                            }}
                            title="Apagar elemento"
                        >
                            <DeleteIcon />
                        </button>
                    )}
                </div>
            </div>

            <div className="properties-content">
                <div className="prop-section">
                    <h4>Geral</h4>
                    <div className="form-group-inline">
                        <label>Label</label>
                        <input
                            value={element.label || ''}
                            onChange={e => handleChange('label', e.target.value)}
                        />
                    </div>
                    {element.type === 'text' && (
                        <div className="form-group-inline">
                            <label>Conteúdo</label>
                            <textarea
                                value={element.content || ''}
                                onChange={e => handleChange('content', e.target.value)}
                                rows={3}
                            />
                        </div>
                    )}
                </div>

                <div className="prop-section">
                    <h4>Posicionamento</h4>
                    <div className="prop-row">
                        <div className="form-group-inline">
                            <label>X</label>
                            <input
                                type="number"
                                value={Math.round(element.x_position)}
                                onChange={e => handleChange('x_position', parseInt(e.target.value))}
                            />
                        </div>
                        <div className="form-group-inline">
                            <label>Y</label>
                            <input
                                type="number"
                                value={Math.round(element.y_position)}
                                onChange={e => handleChange('y_position', parseInt(e.target.value))}
                            />
                        </div>
                    </div>
                    <div className="prop-row">
                        <div className="form-group-inline">
                            <label>L</label>
                            <input
                                type="number"
                                value={Math.round(element.width)}
                                onChange={e => handleChange('width', parseInt(e.target.value))}
                            />
                        </div>
                        <div className="form-group-inline">
                            <label>A</label>
                            <input
                                type="number"
                                value={Math.round(element.height)}
                                onChange={e => handleChange('height', parseInt(e.target.value))}
                            />
                        </div>
                    </div>
                </div>

                <div className="prop-section">
                    <h4>Estilo</h4>
                    <div className="form-group-inline">
                        <label>Tamanho Fonte</label>
                        <input
                            type="number"
                            value={element.styles?.fontSize || 12}
                            onChange={e => handleStyleChange('fontSize', parseInt(e.target.value))}
                        />
                    </div>
                    <div className="form-group-inline">
                        <label>Cor</label>
                        <input
                            type="color"
                            value={element.styles?.color || '#000000'}
                            onChange={e => handleStyleChange('color', e.target.value)}
                        />
                    </div>
                </div>

                <button className="btn-delete-element" onClick={() => onUpdate(element.id, null)}>
                    <DeleteIcon /> Remover Elemento
                </button>
            </div>
        </div>
    );
};

export default PropertiesPanel;
